function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, "\n      .icon_menu_modulos_a{fill:#fff;stroke:#707070;}\n      .icon_menu_modulos_b{clip-path:url(#icon_menu_modulos_a);}\n      .icon_menu_modulos_c{fill:#78909c;}\n      .icon_menu_modulos_d{fill:#687d88;}\n      .icon_menu_modulos_e{fill:#90a4ae;}\n      .icon_menu_modulos_f{fill:#607d8b;}\n      .icon_menu_modulos_g{fill:#7d8f97;}\n      .icon_menu_modulos_h{fill:#546d79;}\n      .icon_menu_modulos_i{fill:#f5f5f5;}\n      .icon_menu_modulos_j{fill:#d5d5d5;}\n    "), React.createElement("clipPath", {
  id: "a"
}, React.createElement("rect", {
  className: "icon_menu_modulos_a",
  width: 19,
  height: 19,
  transform: "translate(1800 1204)"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  className: "icon_menu_modulos_b",
  transform: "translate(-1800 -1204)"
}, React.createElement("g", {
  transform: "translate(1800 1204)"
}, React.createElement("path", {
  className: "icon_menu_modulos_c",
  d: "M5.542,19a.792.792,0,0,1-.792-.792V16.823a.792.792,0,1,1,1.583,0v1.385A.792.792,0,0,1,5.542,19Z"
}), React.createElement("path", {
  className: "icon_menu_modulos_d",
  d: "M5.542,16.031a.792.792,0,0,0-.792.792v1.385A.792.792,0,0,0,5.542,19Z"
}), React.createElement("path", {
  className: "icon_menu_modulos_e",
  d: "M9.5,9.1H2.375V1.385A1.386,1.386,0,0,1,3.76,0H9.5Z"
}), React.createElement("path", {
  className: "icon_menu_modulos_f",
  d: "M9.5,17.417H3.76a1.386,1.386,0,0,1-1.385-1.385V9.1H9.5Z"
}), React.createElement("path", {
  className: "icon_menu_modulos_g",
  d: "M9.5,0H3.76A1.386,1.386,0,0,0,2.375,1.385V9.1H9.5Z"
}), React.createElement("path", {
  className: "icon_menu_modulos_h",
  d: "M9.5,9.1H2.375v6.927A1.386,1.386,0,0,0,3.76,17.417H9.5Z"
}), React.createElement("path", {
  className: "icon_menu_modulos_c",
  d: "M13.458,19a.792.792,0,0,1-.792-.792V16.823a.792.792,0,1,1,1.583,0v1.385A.792.792,0,0,1,13.458,19Z"
}), React.createElement("path", {
  className: "icon_menu_modulos_d",
  d: "M13.458,16.031a.792.792,0,0,0-.792.792v1.385a.792.792,0,0,0,.792.792Z"
}), React.createElement("path", {
  className: "icon_menu_modulos_f",
  d: "M16.625,9.1H9.5V0h5.74a1.386,1.386,0,0,1,1.385,1.385Z"
}), React.createElement("path", {
  className: "icon_menu_modulos_e",
  d: "M15.24,17.417H9.5V9.1h7.125v6.927A1.386,1.386,0,0,1,15.24,17.417Z"
}), React.createElement("path", {
  className: "icon_menu_modulos_i",
  d: "M11.677,15.042a.594.594,0,0,1-.594-.594V13.26a.594.594,0,0,1,1.188,0v1.188A.594.594,0,0,1,11.677,15.042Z"
}), React.createElement("path", {
  className: "icon_menu_modulos_i",
  d: "M11.677,7.125a.594.594,0,0,1-.594-.594V5.344a.594.594,0,0,1,1.188,0V6.531A.594.594,0,0,1,11.677,7.125Z"
}), React.createElement("path", {
  className: "icon_menu_modulos_i",
  d: "M7.323,7.125a.594.594,0,0,1-.594-.594V5.344a.594.594,0,0,1,1.188,0V6.531A.594.594,0,0,1,7.323,7.125Z"
}), React.createElement("path", {
  className: "icon_menu_modulos_i",
  d: "M7.323,15.042a.594.594,0,0,1-.594-.594V13.26a.594.594,0,0,1,1.188,0v1.188A.594.594,0,0,1,7.323,15.042Z"
}), React.createElement("path", {
  className: "icon_menu_modulos_j",
  d: "M7.323,4.75a.594.594,0,0,0-.594.594V6.531a.594.594,0,0,0,.594.594Z"
}), React.createElement("path", {
  className: "icon_menu_modulos_j",
  d: "M7.323,12.667a.594.594,0,0,0-.594.594v1.188a.594.594,0,0,0,.594.594Z"
}), React.createElement("path", {
  className: "icon_menu_modulos_j",
  d: "M11.677,4.75a.594.594,0,0,0-.594.594V6.531a.594.594,0,0,0,.594.594Z"
}), React.createElement("path", {
  className: "icon_menu_modulos_j",
  d: "M11.677,12.667a.594.594,0,0,0-.594.594v1.188a.594.594,0,0,0,.594.594Z"
})));

var SvgModulos = function SvgModulos(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgModulos, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/modulos.1293d649.svg";
export { ForwardRef as ReactComponent };